<template>
  <div class="main-menu-item" :class="{ active }">
    <div class='icon-and-text-section'>
      <div class="icon" :style="{ border: !icon ? 'none' : ''}">
        <slot name="icon">
          <img :src="require(`../assets/icons/${icon}`)" v-if="icon.endsWith('.svg')" />
          <v-icon :class="{'material-icons-round':(rounded)}" v-else>{{ icon }}</v-icon>
        </slot>
      </div>
      <div class="full-name" v-if="!collapsed">
        <slot name="title">{{ title }}</slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MainMenuItem',
  props: {
    title: String,
    icon: String,
    active: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.main-menu-item {
  color: var(--sidebar-text);
  border: solid $border-width-thin transparent;
  border-radius: $radius-md;
  padding-right: $space-1;
  padding-left: $space-1;
  box-sizing: border-box;
  width: 100%; // fill sidebar width so active bg never overflows
  &:hover{
    border-color: var(--sidebar-hover-border);
  }
  .icon-and-text-section {
    width: 100%;
    min-height: unquote("min(#{$space-16}, 6vh)");
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    justify-content: center;
    gap: unquote("min(#{$space-2}, 0.5vh)");
    padding: unquote("min(#{$space-1}, 0.3vh)") 0;
    .full-name {
      font-size: unquote("min(#{$font-size-xs}, 1.3vh)");
      line-height: unquote("min(#{$font-size-sm}, 1.6vh)");
      width: 100%;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .icon {
      align-items: center;
      margin-bottom: 0;
      display: flex;
      justify-content: center;
      font-weight: 900;
      width: unquote("min(#{$space-10}, 4vh)");
      height: unquote("min(#{$space-10}, 4vh)");
      overflow: visible;
      flex-shrink: 0;

      .v-icon {
        color: var(--sidebar-text);
        font-size: unquote("min(#{$space-8}, 3.2vh)");
      }
    }
  }

  &.active {
    background: var(--sidebar-active-bg);
    color: var(--sidebar-active-text);
    .icon {
      .v-icon {
        color: var(--sidebar-active-text);
      }
    }
  }
}
</style>
